import { createContext, useContext } from 'react'

import type { AppNotificationCategory } from '../../../../services/notification'

export const NotificationCategoriesContext = createContext<AppNotificationCategory[]>([])

export const useNotificationCategories = (): AppNotificationCategory[] =>
  useContext(NotificationCategoriesContext)
